var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 20.4,
    viewBox: "0 0 21.5 20.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart-add",
    transform: "translate(-1.25 -2.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M17.2,22.75a5.55,5.55,0,1,1,5.55-5.55A5.557,5.557,0,0,1,17.2,22.75Zm0-9.6a4.05,4.05,0,1,0,4.05,4.05,4.059,4.059,0,0,0-4.05-4.05Z",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M18.99,18.01H15.4a.75.75,0,0,1,0-1.5h3.59a.75.75,0,0,1,0,1.5Z",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M17.2,19.85a.755.755,0,0,1-.75-.75V15.51a.75.75,0,0,1,1.5,0V19.1A.755.755,0,0,1,17.2,19.85Z",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M12,21.65a2.65,2.65,0,0,1-.87-.13c-2.56-.87-9.88-5.11-9.88-12.83A6.3,6.3,0,0,1,12,4.19a6.3,6.3,0,0,1,10.75,4.5,11.743,11.743,0,0,1-1.4,5.57.751.751,0,0,1-1.21.16,4.045,4.045,0,0,0-5.96,5.47.738.738,0,0,1,.17.65.778.778,0,0,1-.42.53c-.4.18-.76.33-1.09.44a2.177,2.177,0,0,1-.84.14ZM7.56,3.85A4.831,4.831,0,0,0,2.75,8.69c0,6.84,6.57,10.62,8.87,11.41a1.467,1.467,0,0,0,.75,0l.09-.03a5.548,5.548,0,0,1,7.98-7.38,10.214,10.214,0,0,0,.81-4A4.8,4.8,0,0,0,12.6,5.78a.774.774,0,0,1-1.2,0A4.812,4.812,0,0,0,7.56,3.85Z",
    fill: "#292d32"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartAdd);
export default __webpack_public_path__ + "static/media/heart-add.596f8a0cb0f5bf31787d67d36bc00318.svg";
export { ForwardRef as ReactComponent };